import { SET_IS_SHRUNK_HEADER } from "../../global/actions/global-actions-types";

const INITIAL_STATE_SET_IS_SHRUNK_HEADER = { isShrunkHeader: '' }

export function setIsShrunkHeaderReducer(state = INITIAL_STATE_SET_IS_SHRUNK_HEADER, action) {
    switch (action.type) {
        case SET_IS_SHRUNK_HEADER:
            return { isShrunkHeader: action.payload }
        default:
            return state;
    }
}